import React, {
  useEffect,
  useState,
} from "react";

import AdminLayout from "./AdminLayout";

const AdminHolidays = () => {

  const [title, setTitle] =
    useState("");

  const [file, setFile] =
    useState(null);

  const [data, setData] =
    useState([]);

  const [editId, setEditId] =
    useState(null);

  const fetchData = async () => {

    try {

      const res = await fetch(
        "https://stjosephweb.ilakshyaerp.in/api/holidays/all"
      );

      const result =
        await res.json();

      setData(
        Array.isArray(result)
          ? result
          : []
      );

    } catch {

      alert("Failed to load holidays");

    }
  };

  useEffect(() => {

    fetchData();

  }, []);

  const resetForm = () => {

    setTitle("");
    setFile(null);
    setEditId(null);

  };

  const handleSubmit =
    async () => {

      if (!title || !file) {

        alert(
          "Please fill all fields"
        );

        return;

      }

      try {

        const formData =
          new FormData();

        formData.append(
          "title",
          title
        );

        formData.append(
          "file",
          file
        );

        const url = editId
          ? `https://stjosephweb.ilakshyaerp.in/api/holidays/update/${editId}`
          : "https://stjosephweb.ilakshyaerp.in/api/holidays/add";

        const method =
          editId ? "PUT" : "POST";

        const res = await fetch(
          url,
          {
            method,
            body: formData,
          }
        );

        const data =
          await res.json();

        alert(data.message);

        resetForm();

        fetchData();

      } catch {

        alert(
          "Upload failed ❌"
        );

      }
    };

  const handleDelete =
    async (id) => {

      if (
        !window.confirm(
          "Delete this holiday?"
        )
      )
        return;

      try {

        const res = await fetch(
          `https://stjosephweb.ilakshyaerp.in/api/holidays/delete/${id}`,
          {
            method: "PUT",
          }
        );

        const data =
          await res.json();

        alert(data.message);

        fetchData();

      } catch {

        alert(
          "Delete failed ❌"
        );

      }
    };

  const handleEdit = (
    item
  ) => {

    setTitle(item.title);

    setEditId(item.id);

  };

  return (

    <AdminLayout>

      <div className="p-8">

        {/* FORM */}

        <div className="bg-white rounded-2xl shadow-lg p-8 border mb-10">

          <h2 className="text-3xl font-bold text-[#0A3470] mb-6">

            Holiday Management

          </h2>

          <div className="grid md:grid-cols-2 gap-5">

            <input
              type="text"
              placeholder="Enter Month Name"
              value={title}
              onChange={(e) =>
                setTitle(e.target.value)
              }
              className="border-2 border-gray-200 rounded-xl px-5 py-3 outline-none focus:border-blue-800"
            />

            <input
              type="file"
              onChange={(e) =>
                setFile(
                  e.target.files[0]
                )
              }
              className="border-2 border-gray-200 rounded-xl px-5 py-3"
            />

          </div>

          <button
            onClick={handleSubmit}
            className="mt-6 bg-[#0A3470] hover:bg-blue-900 text-white px-8 py-3 rounded-xl font-semibold transition"
          >

            {
              editId
                ? "Update Holiday"
                : "Upload Holiday"
            }

          </button>

        </div>

        {/* TABLE */}

        <div className="bg-white rounded-2xl shadow-lg border overflow-hidden">

          <div className="bg-[#0A3470] px-6 py-4">

            <h2 className="text-2xl font-bold text-white">

              All Holidays

            </h2>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full">

              <thead className="bg-gray-100">

                <tr>

                  <th className="p-4 text-left">
                    Preview
                  </th>

                  <th className="p-4 text-left">
                    Month
                  </th>

                  <th className="p-4 text-left">
                    Type
                  </th>

                  <th className="p-4 text-center">
                    Actions
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  data.length > 0
                    ? (
                      data.map(
                        (item) => (

                          <tr
                            key={item.id}
                            className="border-t"
                          >

                            <td className="p-4">

                              {
                                item.type ===
                                "image"
                                  ? (

                                    <img
                                      src={`https://stjosephweb.ilakshyaerp.in/uploads/holidays/${item.file}`}
                                      alt=""
                                      className="w-32 h-24 object-cover rounded-lg border"
                                    />

                                  )
                                  : (

                                    <a
                                      href={`https://stjosephweb.ilakshyaerp.in/uploads/holidays/${item.file}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="text-blue-700 font-semibold"
                                    >
                                      View PDF
                                    </a>

                                  )
                              }

                            </td>

                            <td className="p-4 font-semibold">

                              {item.title}

                            </td>

                            <td className="p-4 uppercase">

                              {item.type}

                            </td>

                            <td className="p-4">

                              <div className="flex justify-center gap-3">

                                <button
                                  onClick={() =>
                                    handleEdit(
                                      item
                                    )
                                  }
                                  className="bg-yellow-500 hover:bg-yellow-600 text-white px-5 py-2 rounded-lg"
                                >
                                  Edit
                                </button>

                                <button
                                  onClick={() =>
                                    handleDelete(
                                      item.id
                                    )
                                  }
                                  className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg"
                                >
                                  Delete
                                </button>

                              </div>

                            </td>

                          </tr>

                        )
                      )
                    )
                    : (
                      <tr>

                        <td
                          colSpan="4"
                          className="text-center py-10 text-gray-500"
                        >

                          No holidays uploaded

                        </td>

                      </tr>
                    )
                }

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </AdminLayout>
  );
};

export default AdminHolidays;